exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[type=checkbox]{transform:scale(1.5)}.cbcontainer{text-align:center;padding-top:7px}.filteredGrid{margin-bottom:1.5em}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/grid.css
 ** module id = 486
 ** module chunks = 0
 **/